import styled, { css } from "styled-components"

import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
} from "recoil"
import { sizeState, userObjState } from "./recoil-atom"

export const Size = () => {
  const [size, setSize] = useRecoilState(sizeState)

  return <>{JSON.stringify(size)}</>
}

export const Flex = styled.div`
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  ${(props) =>
    props.height &&
    css`
      height: ${props.height}px;
    `}
  display: flex;
  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}
  ${(props) =>
    props.spaceBetween &&
    css`
      justify-content: space-between;
    `}
  ${(props) =>
    props.spaceAround &&
    css`
      justify-content: space-around;
    `}
  ${(props) =>
    props.right &&
    css`
      justify-content: flex-end;
    `}
  align-items: center;
  text-align: cetner;
  ${(props) =>
    props.button &&
    css`
      cursor: pointer;
    `}
`

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}
  ${(props) =>
    props.top &&
    css`
      justify-content: flex-start;
    `}
  ${(props) =>
    props.bottom &&
    css`
      justify-content: flex-end;
    `}
  align-items: center;
  text-align: cetner;
`

export const Input = styled.input`
  margin: 0 3px;
  // border: solid 1px #444;
  border: none;
  border-radius: 5px;
  padding: 5px;
  outline: none;
  background-color: #f5f5f5;
  ${(props) =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `}
  color: #444;
  font-size: 1rem;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #aaa;
    opacity: 1; /* Firefox */
  }
  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #aaa;
  }
`

export const Textarea = styled.textarea`
  overflow: hidden;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  border: solid 1px #aaa;
  border-radius: 5px;
  outline: none;
  padding: 10px;
  background-color: #eee;
  color: #111;
  font-size: 16px;
`

export const Submit = styled.input`
  margin: 0 3px;
  // border: solid 1px #444;
  border: none;
  border-radius: 5px;
  padding: 5px 0;
  outline: none;
  background-color: #f5f5f5;
  ${(props) =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `}
  color: #eee;
  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
  font-size: 1rem;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  text-align: center;
  cursor: pointer;
`

export const DivRound = styled.div`
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  margin: 11px auto 0 auto;
  border-radius: 20px;
  padding: 10px 0;
  background-color: #f5f5f5;
  ${(props) =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `}
  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
  ${(props) =>
    props.boxShadow &&
    css`
      box-shadow: ${props.boxShadow};
    `}
  ${(props) =>
    props.button &&
    css`
      cursor: pointer;
    `}
`

export const Button = styled.div`
  cursor: pointer;
`

export const ListPages = styled.div`
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  margin: 10px auto 0 auto;
  border-radius: 20px;
  padding: 10px 0;
  ${(props) =>
    props.page === 2 &&
    css`
      padding: 10px 20px;
    `}
  background-color: #ddd;
  ${(props) =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `}
  ${(props) =>
    props.boxShadow &&
    css`
      box-shadow: ${props.boxShadow};
    `}
  display: grid;
  grid-template-columns: repeat(${(props) => props.page}, 1fr);
  gap: 20px;
`

export const PageMarks = styled(FlexColumn)`
  justify-content: flex-start;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  margin: 10px auto 0 auto;
  border-radius: 20px;
  padding: 10px 0;
  background-color: #f5f5f5;
  ${(props) =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `}
  ${(props) =>
    props.boxShadow &&
    css`
      box-shadow: ${props.boxShadow};
    `}
`

export const GroupMarks = styled.div`
  padding: 0 5px;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  min-width: 360px;
  display: grid;
  grid-template-columns: repeat(${(props) => props.item}, 1fr);
  justify-items: center;
  align-items: start;
`

export const Mark = styled.div`
  position: relative;
  height: 110px;
  width: 80px;
  max-width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  font-size: 12px;
  font-weight: 300;
  &:hover {
    transform: scale(1.05);
  }
`

export const MarkEdit = styled.div`
  position: relative;
  height: 110px;
  width: 80px;
  max-width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  font-size: 12px;
  /* &:hover {
    transform: scale(1.1);
  } */
`

export const MarkIcon = styled.div`
  width: 64px;
  height: 64px;
  min-height: 64px;
  box-shadow: 1px 1px 6px -1px #ccc;
  margin: 4px 0 5px 0;
  border-radius: 12px;
  padding: 5px;
  ${(props) =>
    props.thumbnail &&
    css`
      background-image: url(${props.thumbnail});
      background-size: cover;
      background-position: center center;
    `}
  ${(props) =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
      color: ${props.color};
    `}
  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
`

export const MarkAction = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`
